import { TERMS } from '../../constants/terms.js';
import { getAmountRangeToString, generateTermRange, humanizeTermBestEdge } from '../../helpers/humanization.js';
import { plur } from '../../helpers/plur.js';

const getCreditsTerms = item => {
    const conditions = [];
    const { sumFrom, sumTo, currency, unitTo, minTermFrom, maxTermTo } = item;
    const amount = {
        from: sumFrom,
        to: sumTo,
    };
    const amountValue = getAmountRangeToString({ amountRange: amount, currency, isConvert: true });
    let term;
    if (['months', 'years'].includes(unitTo)) {
        const termRange = generateTermRange({
            dictDateFrom: [TERMS[unitTo]],
            dictDateTo: [TERMS[unitTo]],
            to: maxTermTo,
            from: minTermFrom,
        });
        term = humanizeTermBestEdge(termRange);
    }
    else if (minTermFrom && maxTermTo) {
        if (minTermFrom === maxTermTo) {
            term = `${minTermFrom} мес. – ${maxTermTo} ${plur({
                value: maxTermTo,
                unit: TERMS.years,
                initialForm: false,
            })}`;
        }
        else {
            term = `до ${maxTermTo} ${plur({
                value: maxTermTo,
                unit: TERMS.years,
                initialForm: false,
            })}`;
        }
    }
    else if (maxTermTo) {
        term = `до ${maxTermTo} ${plur({
            value: maxTermTo,
            unit: TERMS.years,
            initialForm: false,
        })}`;
    }
    else if (minTermFrom) {
        term = `от ${minTermFrom} ${plur({
            value: minTermFrom,
            unit: TERMS.months,
            initialForm: false,
        })}`;
    }
    conditions.push({ value: amountValue, description: 'Сумма', key: 'amount' });
    term && conditions.push({ value: term, description: 'Срок', key: 'term' });
    return conditions;
};

export { getCreditsTerms };
//# sourceMappingURL=credits.js.map
